// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import { customAuthStorage } from '@/lib/customAuthStorage';

// 🔒 SEGURANÇA: Usar variáveis de ambiente - SEM fallbacks hardcoded
const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
const SUPABASE_PUBLISHABLE_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY;

// Validar que as variáveis de ambiente estão configuradas
if (!SUPABASE_URL || !SUPABASE_PUBLISHABLE_KEY) {
  console.error('[Supabase] Missing environment variables:', {
    hasUrl: !!SUPABASE_URL,
    hasKey: !!SUPABASE_PUBLISHABLE_KEY,
  });
  throw new Error(
    '❌ ERRO DE CONFIGURAÇÃO: Variáveis de ambiente Supabase não configuradas.\n' +
    'Configure VITE_SUPABASE_URL e VITE_SUPABASE_ANON_KEY no arquivo .env.local\n' +
    'Exemplo:\n' +
    'VITE_SUPABASE_URL=https://seu-projeto.supabase.co\n' +
    'VITE_SUPABASE_ANON_KEY=sua-chave-anonima'
  );
}

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    // 🌐 Custom storage que usa cookies (compartilhados entre subdomínios) + localStorage (backup)
    storage: customAuthStorage,
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    // 🔒 Storage key único para o ImobPanda
    storageKey: 'imobpanda-auth-token',
    flowType: 'pkce', // Proof Key for Code Exchange (mais seguro)
  },
  global: {
    headers: {
      // 🔒 CSRF Protection: Custom header para validação
      'X-Client-Info': 'imobpanda-web',
    },
  },
});